// extracted by mini-css-extract-plugin
module.exports = {"instaFeed":"instaFeed-module--insta-feed--3vjaD","instaList":"instaFeed-module--insta-list--1QKXh","followButton":"instaFeed-module--follow-button--1CONM"};